module.exports = __webpack_public_path__ + "media/images/wf_logo.1-3754e99a8cab223b1f43c8fece21567a.png";